import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IUpdateAdminProfileParams {
  luid: string;
  name: string;
  description: string;
  permissions: Array<{
    capability: string;
    resource: string;
  }>;
}

export interface IUpdateAdminProfileResult extends IResult {
  luid: string;
}

export class UpdateAdminProfileRequest extends Request<IUpdateAdminProfileParams, IUpdateAdminProfileResult> {
  constructor(params: IUpdateAdminProfileParams) {
    super('updateAdminProfile', params);
  }
}
